export default "__VITE_ASSET__22f50db7__"